module.exports = __webpack_public_path__ + "img/g8.c4a8c36e.jpg";